import { CardInfoListFilter } from '../../../types';
import { CardStatusesResponseDTO } from '../entities/CardStatuses/CardStatusesResponseDTO';

export const cardStatusesResponseDTOtoCardStatusesAdapter = (data: CardStatusesResponseDTO): CardInfoListFilter => {
  if (!data.body) {
    throw new Error();
  }

  return data.body;
};
